import { createSlice } from "@reduxjs/toolkit";
import { app_reset, set_app_state } from "../App/reducer";

const a11yNotificationText = (title) => {
    return title ? title + " Loaded" : "";
};

const setInitialState = () => ({
    a11yNotificationText: "",
});

const a11ySlice = createSlice({
    name: "a11y",
    initialState: setInitialState(),
    reducers: {
        setA11yNotificationText: (state, action) => {
            state.a11yNotificationText = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(set_app_state, (state, action) => {
            state.a11yNotificationText = a11yNotificationText(
                action?.payload?.app?.title
            );
        });
        builder.addCase(app_reset, (state) => {
            state.a11yNotificationText = "";
        });
    },
});

export const { setA11yNotificationText } = a11ySlice.actions;

export default a11ySlice.reducer;
